import { BrandColors } from '../theme';

export const skeletonTokens = {
    root: {
        borderRadius: '6px',
    },
    colorScheme:{
        light: {
            root: {
                background: BrandColors.gray[200],
                animationBackground: BrandColors.gray[200],
            }
        }
    }
};    